function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16.125,
    viewBox: "0 0 24 16.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "visible (1)",
    d: "M41.235 105.2a11.839 11.839 0 0 1-20.7 0 .882.882 0 0 1 0-.891 11.839 11.839 0 0 1 20.7 0 .869.869 0 0 1 0 .891zm1.336-1.636a13.367 13.367 0 0 0-23.367 0 2.394 2.394 0 0 0 0 2.379 13.367 13.367 0 0 0 23.367 0 2.394 2.394 0 0 0-.001-2.382zm-11.682 4.328a3.139 3.139 0 1 0-3.141-3.139 3.142 3.142 0 0 0 3.14 3.136zm0-7.807a4.669 4.669 0 1 0 4.668 4.669 4.674 4.674 0 0 0-4.669-4.672z",
    transform: "translate(-18.887 -96.688)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.13df2b67327e581dd56f0c8ad343e672.svg";
export { ForwardRef as ReactComponent };